import AppConstants from "@/appConstants";
import apiService from "./apiService";

class DropdownService {
    getAllOrigin(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_ORIGIN, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllHeader(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_ALL_USERHEADER, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }

      getUserHeader(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_USERHEADER, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllLocale(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_LOCALE_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllPermission(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_PERMISSION_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllTopic(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_TOPIC_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllProfile(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_PROFIILE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllClientProfile(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CLIENT_PROFILE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllSubjects(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_SUBJECT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getAllReportTypeGroups(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_REPORT_TYPE_GROUPS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getSubjectsSafrasPlatform(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_SUBJECT_SAFRAS_PLATFORM, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllTags(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_TAG, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllKeyReference(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_KEY_REFERENCE_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllCategory(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CATEGORY_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllCountries(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_COUNTRY, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }

      getAllLanguage(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_LANGUAGE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }

      getAllLogicalNumber(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_LOGICAL_NUMBER, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }

      getTypeMessages(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_TYPE_MESSAGES, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }

      getEventStatus(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_EVENT_STATUS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getUsers(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_USERS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }

      getUserSignature(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_USER_SIGNATURE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }

      getAcronyms(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_USER_ACRONYMS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }

      getHat(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_HAT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      
      getContent(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CONTENT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }

      getContentBySubject(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CONTENT_SUBJECT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getContentBySubjectUserRule(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CONTENT_SUBJECT_USERRULE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }

      // REPORT DROPDOWN
      getCountry(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_COUNTRY, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getLanguage(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_LANGUAGE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getCommodity(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_COMMODITY, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getReportType(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_REPORT_TYPE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getPackage(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_PACKAGE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getCharacteristic(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CHARACTERISTIC, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getPeriodicity(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_PERIODICITY, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getChannel(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CHANNEL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getChannelByOrigin(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CHANNEL_ORIGIN, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getAuditlogAction(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_AUDITLOG_ACTION, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getAuditlogName(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_AUDITLOG_NAME, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getCategory(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CATEGORY, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getCategoryByChannel(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CATEGORY_CHANNEL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getClientGroup(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CLIENT_GROUP, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getPlatformLocation(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_PLATFORM_LOCATION, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getClientSignatures(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CLIENT_SIGNATURES, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getClientRegisterSystemFrom(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CLIENT_REGISTER_SYSTEM_FROM, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getTopic(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_TOPIC, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getPlatformSystemType(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_PLATFORM_SYSTEM_TYPE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getChartEvents(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CHART_EVENTS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getChartMarket(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CHART_MARKET, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getAssetReference(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_ASSET_REFERENCE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getUserCategoriesField(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_USER_CATEGORIES_FIELD, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getUserCore(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_USER_CORE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getPublisherServices(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_PUBLISHER_SERVICES, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getMdtpProviderService(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_MDTP_PROVIDER_SERVICE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
      getPushServiceType(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_PUSH_SERVICE_TYPE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
}

export default new DropdownService();